import React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import cn from './cn';

/**
 * Radix Popover, replacing Bootstrap's `Overlay` / `OverlayTrigger` / `Popover` trio.
 *
 * Bootstrap's version positions by measuring on every render and needs a `target` ref;
 * Radix uses the floating-ui positioner and handles collision, flipping and scroll
 * containment. Behaviourally that is an upgrade rather than a like-for-like swap, which is
 * why the two call sites are converted deliberately rather than by codemod.
 */
export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;

export const PopoverContent = React.forwardRef(
  ({ className, align = 'center', sideOffset = 6, ...props }, ref) => (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn(
          'tw-z-dialog tw-w-72 tw-rounded-card tw-border tw-border-solid tw-border-line-light',
          'tw-bg-white tw-p-3 tw-shadow-lg tw-font-sans tw-text-body tw-text-ink',
          'tw-animate-cms-fade-in focus:tw-outline-none',
          className
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  )
);
PopoverContent.displayName = 'PopoverContent';

export const PopoverHeader = ({ className, ...props }) => (
  <div
    className={cn(
      'tw--mx-3 tw--mt-3 tw-mb-2 tw-px-3 tw-py-2 tw-rounded-t-card',
      'tw-bg-fill tw-border-0 tw-border-b tw-border-solid tw-border-line-light',
      'tw-text-body tw-font-bold tw-text-ink',
      className
    )}
    {...props}
  />
);
PopoverHeader.displayName = 'PopoverHeader';

export default Popover;
